import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import {
  DeletePriceListProductParams,
  PriceListProductsResponse,
} from '@/api/_schemas/management'
import { deletePriceListProduct } from '@/api/management'
import { ApiError } from '@/config/api'
import { keyStore } from '@/config/key-store'
import { queryClient } from '@/config/query-client'
import { useToast } from '@/hooks/use-toast'
import { handleErrors } from '@/services/fetch'

export const useDeleteProduct = () => {
  const { toastDestructive, toastPositive } = useToast()

  const mutation = useMutation({
    mutationFn: async (params: DeletePriceListProductParams) =>
      await deletePriceListProduct(params),
    onSuccess: (_, { id }) => {
      queryClient
        .getQueryCache()
        .findAll({
          predicate: ({ queryKey }) =>
            Array.isArray(queryKey) &&
            [...keyStore.priceList.products.queryKey].includes(queryKey[0]),
        })
        .forEach(({ queryKey }) => {
          queryClient.setQueryData<PriceListProductsResponse>(
            queryKey,
            (oldData) =>
              oldData && [
                ...oldData.filter(
                  ({ cod_produto_lista_preco: priceListProductId }) =>
                    id !== priceListProductId,
                ),
              ],
          )
        })

      queryClient.refetchQueries({
        queryKey: [...keyStore.priceList.infinite.queryKey],
        exact: false,
      })

      toastPositive('Produto removido da lista.')
    },
    onError: ({ response }: AxiosError<ApiError>) => {
      handleErrors(response?.data, [], toastDestructive)
    },
  })

  return { mutation }
}
